module.exports = __webpack_public_path__ + "static/media/chatapp.3a14e62f.webp";